import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { CompetingAdsLayoutComponent } from './layouts/competing-ads-layout/competing-ads-layout.component';
import { CompetingAdsDatatableComponent } from './components/competing-ads-datatable/competing-ads-datatable.component';

const DECLARATIONS = [
  CompetingAdsLayoutComponent,
  CompetingAdsDatatableComponent
];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class CompetingAdsModule {}
